// src/routes/UserManagementRoutes.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PermissionRoute from './PermissionRoute';

// User Management
import UserRolesPage from '../pages/users/UserRolesPage';
import CreateRolePage from '../pages/users/CreateRolePage';
import EditRolePage from '../pages/users/EditRolePage';
import UsersPage from '../pages/users/UsersPage';
import CreateUserPage from '../pages/users/CreateUserPage';
import EditUserPage from '../pages/users/EditUserPage';

const UserManagementRoutes = () => {
  return (
    <Routes>
      {/* User Management Routes */}
      <Route 
        path="/roles" 
        element={
            <PermissionRoute requiredPermission="view_all_user_roles">
              <UserRolesPage />
            </PermissionRoute>
        } 
      />
      <Route 
        path="/roles/create" 
        element={
            <PermissionRoute requiredPermission="create_user_role">
              <CreateRolePage />
            </PermissionRoute>
        } 
      />
      <Route 
        path="/roles/:roleId/edit" 
        element={
            <PermissionRoute requiredPermission="edit_user_role">
              <EditRolePage />
            </PermissionRoute>
        } 
      />
      <Route 
        path="/" 
        element={
            <PermissionRoute requiredPermission="view_all_users">
              <UsersPage />
            </PermissionRoute>
        } 
      />
      <Route 
        path="/create" 
        element={
            <PermissionRoute requiredPermission="create_user">
              <CreateUserPage />
            </PermissionRoute>
        } 
      />
      <Route 
        path="/:userId/edit" 
        element={
            <PermissionRoute requiredPermission="edit_user">
              <EditUserPage />
            </PermissionRoute>
        } 
      />
    </Routes>
  );
};

export default UserManagementRoutes;